
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21.504 21.823"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.943 7.863V3.798A3.048 3.048 0 009.895.75L5.831 9.895v11.177h11.461a2.032 2.032 0 002.033-1.722l1.4-9.145a2.032 2.032 0 00-2.032-2.337zM5.831 21.072H2.782A2.032 2.032 0 01.75 19.04v-7.113a2.032 2.032 0 012.032-2.032h3.049","fill":"none"}})])
          )
        }
      }
    